export default "__VITE_ASSET__CRLiXudg__"